var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewer",staticClass:"viewer-wrap"},[_c('ul',{staticStyle:{"display":"none"}},_vm._l((_vm.data),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item[_vm.props ? _vm.props.url : 'url'],"alt":item[_vm.props ? _vm.props.name : 'name']}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39865fec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/widgets/image-preview.vue
// module id = null
// module chunks = 